import { useMutation } from '@apollo/client';
import { useApiResponse } from '@libs/hooks';
import { useCallback, useState } from 'react';
import { TOKEN_KEY } from 'src/constants';
import { refreshTokenMutation, RefreshTokenRes } from 'src/gql';

export type RefreshTokenActionContextReturnValue = {
  triggerRefreshToken: () => void;
};
export const useRefreshTokenActionContext =
  (): RefreshTokenActionContextReturnValue => {
    // STARTOF: TOKEN REFRESH
    const [refreshTokenPending, setRefreshTokenPending] = useState(false);

    const handleFailedRefreshToken = setRefreshTokenPending.bind(null, false);
    const handleSuccessRefreshToken = async (data: RefreshTokenRes) => {
      if (data.refreshToken.accessToken) {
        try {
          localStorage.setItem(TOKEN_KEY, data.refreshToken.accessToken);
        } finally {
          setRefreshTokenPending(false);
        }
      }
    };

    const [refreshToken, res] = useMutation(refreshTokenMutation);
    useApiResponse(res, handleSuccessRefreshToken, handleFailedRefreshToken);

    const triggerRefreshToken = useCallback(() => {
      console.log('trigerring token refresh =>');
      if (res.loading || refreshTokenPending) return;
      setRefreshTokenPending(true);
      refreshToken();
    }, [res.loading, refreshToken, refreshTokenPending]);
    // ENDOF: TOKEN REFRESH

    return {
      triggerRefreshToken,
    };
  };
